export const SET_ESTIMATION = "SET_ESTIMATION"

export function setEstimation(estimation){
	return {
		type: SET_ESTIMATION,
		estimation: estimation
	}
}
